import * as angular from 'angular';
import { AuctionResource } from 'app/_resources/auction.resource';
import { SecondaryTradeResource } from 'app/_services/secondaryTradeService';
import { StorageService } from 'app/_services/storageService';
import * as moment from 'pkp-moment-timezone-all-years';
import { config, embedded } from '../../angular/utils/config';

(function () {
    'use strict';

    const TRANSACTION_CARD_TRADE_SESSION_STORAGE_KEY =
        'create-proposal-wizard-transaction-card-data-trade';
    const TRANSACTION_CARD_DEAL_SESSION_STORAGE_KEY =
        'create-proposal-wizard-transaction-card-data-deal';

    angular.module('app').controller('CreateProposalCtrl', CreateProposalCtrl);

    function CreateProposalCtrl(
        $scope,
        $route,
        $controller,
        $routeParams,
        $q,
        createProposalService,
        TradeProposals,
        $location,
        $translate,
        SecondaryTrade: SecondaryTradeResource,
        auctionResource: AuctionResource,
        storageService: StorageService
    ) {
        type OnGoingToStepParams = {
            index: number;
            fromBreadcrumb: boolean;
            fromSummaryCard: boolean;
            previousIndex: number;
        };
        var vm = this;
        var wizardTitle = '';
        var wizardTitleExtension = '';
        var wizardTitleID = '';
        var CAPACITY_SOURCE = createProposalService.CAPACITY_SOURCE;

        vm.ui = {};
        vm.isLoading = false;
        vm.startWith = undefined;
        vm.stages = createProposalService.stages;
        vm.pages = createProposalService.pages;
        vm.service = {};
        vm.onNext = onNext;
        vm.restart = restart;
        vm.finished = finished;
        vm.startNewOne = startNewOne;
        vm.STORAGE_PREFIX = createProposalService.STORAGE_PREFIX;

        const auctionId: string | undefined = $location.search().auctionId;
        const dealId: string | undefined = $location.search().dealId;
        const tradeId: string | undefined = $location.search().tradeId;

        if (auctionId && dealId) {
            vm.deal = {
                pending: true,
                data: null,
                error: null
            };
            const savedDataRaw = storageService.fetchFromSession(
                TRANSACTION_CARD_DEAL_SESSION_STORAGE_KEY
            );
            let savedData = null;
            if (
                savedDataRaw &&
                (savedData = JSON.parse(savedDataRaw)) &&
                savedData.deal.dealId === dealId &&
                savedData.auction.id.toString() === auctionId
            ) {
                vm.deal.data = savedData;
                vm.deal.pending = false;
            } else {
                auctionResource.get(
                    { auctionId },
                    (res: AuctionDetailDto) => {
                        vm.deal.pending = false;

                        const trades = res.trades || [];
                        const deal = trades.find(
                            (trade) => trade.dealId === dealId
                        );
                        if (deal) {
                            vm.deal.data = { deal, auction: res };
                            // persist in local storage
                            storageService.storeToSession(
                                TRANSACTION_CARD_DEAL_SESSION_STORAGE_KEY,
                                JSON.stringify(vm.deal.data)
                            );
                        } else {
                            vm.deal.error = true;
                        }
                    },
                    (error) => {
                        vm.deal.pending = false;
                        vm.deal.error = error;
                    }
                );
            }
        }

        if (tradeId) {
            vm.trade = {
                pending: true,
                data: null,
                error: null
            };
            const savedDataRaw = storageService.fetchFromSession(
                TRANSACTION_CARD_TRADE_SESSION_STORAGE_KEY
            );
            let savedData = null;
            if (
                savedDataRaw &&
                (savedData = JSON.parse(savedDataRaw)) &&
                savedData.response.id.toString() === tradeId
            ) {
                vm.trade.data = savedData;
                vm.trade.pending = false;
            } else {
                SecondaryTrade.get(
                    { id: tradeId },
                    (res: SecondaryTradeDto) => {
                        vm.trade.pending = false;
                        vm.trade.data = res;
                        // persist in local storage
                        storageService.storeToSession(
                            TRANSACTION_CARD_TRADE_SESSION_STORAGE_KEY,
                            JSON.stringify(vm.trade.data)
                        );
                    },
                    (error) => {
                        vm.trade.pending = false;
                        vm.trade.error = error;
                    }
                );
            }
        }

        if (!angular.isUndefined($routeParams.id)) {
            wizardTitle = 'Edit Trade Proposal';
            wizardTitleID = ' ID ' + $routeParams.id;
            if (angular.isUndefined($routeParams.stage)) {
                vm.isLoading = true;
                vm.startWith = 1;
                initAsEdit($routeParams.id);
            }
        } else {
            wizardTitle = 'New Trade Proposal';
        }

        updateTitle();
        updateData();

        function updateData() {
            vm.data = createProposalService.getAllStages();
            vm.data.stageFive.errorSubmittingTradeProposal = false;

            if (!angular.isUndefined(vm.data.stageTwo.intention)) {
                if (
                    vm.data.stageTwo.intention ===
                    createProposalService.INTENTION.SELL
                ) {
                    wizardTitleExtension = ' to Sell';
                } else {
                    wizardTitleExtension = ' to Buy';
                }
                updateTitle();
            }
        }

        function updateTitle() {
            vm.title = wizardTitle + wizardTitleExtension + wizardTitleID;
        }

        function onNext() {
            updateData();
        }

        function restart() {
            createProposalService.reset();
            $scope.$broadcast(createProposalService.BROADCAST.WIZARD_RESTART);
        }

        function finished() {
            onNext();

            var params: any = {
                creationMode: vm.data.stageFive.action
            };
            var actionByWizardType = 'createProposal';
            if (!angular.isUndefined(vm.data.stageFive.id)) {
                actionByWizardType = 'editProposal';
                params.id = vm.data.stageFive.id;
            }

            return TradeProposals[actionByWizardType](
                params,
                mappedData(),
                function (res) {
                    vm.proposal = res;

                    if (embedded) {
                        $location
                            .path(
                                `/react/transport/secondary/proposals/${vm.proposal.id}?action=${vm.data.stageFive.action}`
                            )
                            .replace();
                    } else {
                        location.href = `${config.appBaseUrl}/transport/secondary/proposals/${vm.proposal.id}?action=${vm.data.stageFive.action}`;
                        location.reload();
                    }
                }
            ).$promise;
        }

        function startNewOne() {
            restart();
            $route.updateParams({ stage: null });
        }

        function initAsEdit(proposalId) {
            restart();

            var params = {
                id: proposalId
            };
            TradeProposals.get(params, function (proposal) {
                initStages(proposal);
            });
        }

        // init methods for editing proposal
        function initStages(proposal) {
            var stageOneCtrl = $scope.$new(true);
            $controller('CreateProposalStageOneCtrl', { $scope: stageOneCtrl });
            var promises = {
                networkPointRequest: stageOneCtrl.setDataForNetworkPoint(
                    proposal.networkPoint.id
                ),
                tsoConfigRequest: stageOneCtrl.fetchTsoConfig(
                    proposal.networkPoint.id
                ).$promise,
                channelConfigRequest: stageOneCtrl.fetchChannelConfig()
            };

            $q.all(promises).then(function () {
                vm.isLoading = false;
                initStageTwo(proposal);
                initStageThree(proposal);
                initStageFour(proposal);
                initStageFive(proposal);
                updateData();
                $route.updateParams({ stage: 1 });
                createProposalService.setEditStage();
            });
        }

        function initStageTwo(proposal) {
            var stageTwo: any = {};

            if (
                proposal.proposalType === createProposalService.INTENTION.SELL
            ) {
                stageTwo.intention = createProposalService.INTENTION.SELL;
            } else {
                stageTwo.intention = createProposalService.INTENTION.BUY;
            }
            stageTwo.combineUnderlyingContract = proposal.combineUnbundledDeals;

            createProposalService.setStageTwo(stageTwo);
        }

        function initStageThree(proposal) {
            var stageThree = {
                procedure: proposal.tradingProcedure,
                transactionType: proposal.transactionType,
                anonymous: proposal.completelyAnonymous,
                counterparty: {
                    shipper: proposal.otcCounterparty,
                    eic: createProposalService.getEic(proposal.otcCounterparty),
                    emails: proposal.otcEmails
                },
                offer: {
                    capacity: {
                        unit: proposal.amount.originalUnit,
                        value: {
                            floatingPointNumber: true,
                            value: proposal.amount.originalValue.value
                                .toNumber()
                                .toString()
                        }
                    },
                    runtime: proposal.runtime,
                    price: proposal.price
                },
                rules: {
                    minLotSize: proposal.minimumLotSize,
                    minLotRuntime: fromMinimumLotRuntime(
                        proposal.minimumLotRuntime
                    ),
                    completeLotRuntime: false,
                    submissionWindowClosure: moment(
                        proposal.submissionWindowClosure
                    ).toDate(),
                    expirationDate: moment(proposal.expirationDate).toDate(),
                    restrictParticipates: !angular.isUndefined(
                        proposal.traderList
                    ),
                    traderList: proposal.traderList,
                    conditions: {
                        id: proposal.tradingConditionsId,
                        name: proposal.tradingConditionsName
                    }
                }
            };

            createProposalService.setStageThree(stageThree);
        }

        function initStageFour(proposal) {
            var stageFour = {
                details0: fromComponent(proposal, 0),
                details1: {}
            };

            if (!angular.isUndefined(proposal.components[1])) {
                stageFour.details1 = fromComponent(proposal, 1);
            }

            createProposalService.setStageFour(stageFour);
        }

        function initStageFive(proposal) {
            var stageFive = {
                id: proposal.id
            };

            createProposalService.setStageFive(stageFive);
        }

        function fromComponent(proposal, index) {
            var component = proposal.components[index];

            var mapped: any = {
                balancingGroup: component.balancingGroup,
                portfolio: component.portfolioCode,
                capacityCategory: component.capacityCategory,
                auctionSurcharge: component.underlyingSurcharge,
                regulatedTariff: component.underlyingRegulatedTariff,
                isRegulatedTariff: component.isRegulatedTariff
            };

            if (!angular.isUndefined(component.underlyingDealId)) {
                mapped.capacityContractId =
                    component.underlyingDealId.identifier;
                mapped.capacityContract = {
                    dealId: component.underlyingDealId.identifier
                };
                mapped.capacitySource = component.underlyingDealId.source;
                if (
                    component.underlyingDealId.source !==
                    CAPACITY_SOURCE.MANUAL_INPUT
                ) {
                    var promise = fetchAndSetUnderlyingDeal(
                        component.underlyingDealId.identifier,
                        proposal.networkPoint.id,
                        component.underlyingDealId.source,
                        proposal.runtime
                    );
                    // update capacity contract as soon as async process finished (UI should preselect this deal then)
                    promise.then(function (res) {
                        var stageFour = createProposalService.getStageFour();
                        stageFour['details' + index].capacityContract = res[0];
                        createProposalService.setStageFour(stageFour);
                    });
                }
            }

            return mapped;
        }

        function fetchAndSetUnderlyingDeal(
            id,
            networkPointId,
            source,
            runtime
        ) {
            return TradeProposals.underlyingDeals(
                {
                    networkPointId: networkPointId,
                    underlyingDealSource: source,
                    runtimeStart: runtime.start,
                    runtimeEnd: runtime.end
                },
                function (res) {
                    for (var i = 0; i < res.length; i++) {
                        if (res[i].dealId === id) {
                            return res[i];
                        }
                    }
                }
            ).$promise;
        }

        // under this line your will find all the mappings for backend
        function mappedData() {
            var physicalUnit = $translate
                .instant(
                    'PhysicalUnit.' +
                        vm.data.stageOne.selectedNetworkPoint.physicalUnit
                )
                .replace('&#179;', '³');

            var price = null;
            if (
                !angular.isUndefined(vm.data.stageThree.offer.price) &&
                vm.data.stageThree.offer.price !== null
            ) {
                price = vm.data.stageThree.offer.price;
            }

            var minLotSizeQuantity;
            if (vm.data.stageThree.rules.minLotSize.originalValue) {
                minLotSizeQuantity = vm.data.stageThree.rules.minLotSize;
            }

            var mappedObj: any = {
                id: vm.data.stageFive.id,

                networkPointRef: vm.data.stageOne.selectedNetworkPoint.id,

                proposalType: vm.data.stageTwo.intention,
                combineUnbundledDeals:
                    vm.data.stageTwo.combineUnderlyingContract,

                transactionType: vm.data.stageThree.transactionType,
                tradingProcedure: vm.data.stageThree.procedure,
                otcCounterparty: mapShipper(vm.data.stageThree.counterparty),
                otcEmails: vm.data.stageThree.counterparty
                    ? vm.data.stageThree.counterparty.emails
                    : undefined,
                amount: {
                    value: vm.data.stageThree.offer.capacity.value,
                    unit: physicalUnit
                },
                price: price,
                runtime: vm.data.stageThree.offer.runtime,
                expirationDate:
                    typeof vm.data.stageThree.rules.expirationDate === 'string'
                        ? vm.data.stageThree.rules.expirationDate
                        : vm.data.stageThree.rules.expirationDate.toISOString(),
                completelyAnonymous: vm.data.stageThree.anonymous,
                minimumLotSize: minLotSizeQuantity,
                minimumLotRuntime: toMinimumLotRuntime(
                    vm.data.stageThree.rules.minLotRuntime,
                    vm.data.stageThree.offer.runtime.start,
                    vm.data.stageThree.offer.runtime.end
                ),
                traderList: vm.data.stageThree.rules.restrictParticipates
                    ? vm.data.stageThree.rules.traderList.name
                    : undefined,
                tradingConditionsId: vm.data.stageThree.rules.conditions.id,

                components: buildComponents(),

                comment: vm.data.stageFour.tradeProposalComment
            };
            if (
                vm.data.stageThree.procedure ===
                createProposalService.PROCEDURE.CFO
            ) {
                mappedObj.submissionWindowClosure =
                    typeof vm.data.stageThree.rules.submissionWindowClosure ===
                    'string'
                        ? vm.data.stageThree.rules.submissionWindowClosure
                        : vm.data.stageThree.rules.submissionWindowClosure.toISOString();
            }
            return mappedObj;
        }

        function mapShipper(counterparty) {
            if (!angular.isUndefined(counterparty)) {
                if (counterparty.eic) {
                    return {
                        identifierList: [
                            {
                                type: 'EIC',
                                id: counterparty.eic
                            }
                        ]
                    };
                } else {
                    return counterparty.shipper;
                }
            }
        }

        function toMinimumLotRuntime(minLotRuntime, runtimeStart, runtimeEnd) {
            var result;
            if (!vm.data.stageThree.rules.completeLotRuntime) {
                if (!minLotRuntime) {
                    return null;
                }
                result = {
                    value: minLotRuntime.value,
                    type: minLotRuntime.unit
                };
            } else {
                var runtimeDurationInDays = moment(runtimeEnd).diff(
                    moment(runtimeStart),
                    'days'
                );
                result = {
                    value: runtimeDurationInDays,
                    type: createProposalService.minLotRuntimeUnits.DAY
                };
            }
            return result;
        }

        function fromMinimumLotRuntime(minimumLotRuntime) {
            if (
                !angular.isUndefined(minimumLotRuntime) &&
                !angular.isUndefined(minimumLotRuntime.value) &&
                !angular.isUndefined(minimumLotRuntime.type)
            ) {
                return {
                    value: minimumLotRuntime.value,
                    unit: minimumLotRuntime.type
                };
            }
        }

        function buildComponents() {
            var components = [];

            components.push(buildComponent('0'));

            if (vm.data.stageOne.selectedNetworkPoint.bundled) {
                components.push(buildComponent('1'));
            }

            return components;
        }

        function buildComponent(id) {
            var details = vm.data.stageFour['details' + id];

            var componentObj: any = {
                underlyingSurcharge:
                    !!details.auctionSurcharge &&
                    !!details.auctionSurcharge.originalValue &&
                    details.auctionSurcharge.originalValue.value !== null
                        ? details.auctionSurcharge
                        : undefined,
                balancingGroup: details.balancingGroup,
                portfolioCode: details.portfolio,
                capacityCategory: details.capacityCategory
            };

            if (
                !!details.regulatedTariff &&
                !!details.regulatedTariff.originalValue &&
                details.regulatedTariff.originalValue.value !== null
            ) {
                componentObj.underlyingRegulatedTariff =
                    details.regulatedTariff;
            }

            if (details.commodityFee) {
                componentObj.commodityFee = details.commodityFee;
            }

            componentObj.underlyingDealId = {
                identifier: details.capacityContractId,
                source: details.capacitySource
            };
            if (
                id === '1' &&
                !details.capacityContractId &&
                vm.data.stageOne.selectedNetworkPoint.bundled &&
                !vm.data.stageTwo.combineUnderlyingContract &&
                vm.data.stageFour.details0.capacityContractId
            ) {
                //backend needs for bundled cases with only one deal id the same id in both components
                componentObj.underlyingDealId = {
                    identifier: vm.data.stageFour.details0.capacityContractId,
                    source: vm.data.stageFour.details0.capacitySource
                };
            }

            if (id === '1') {
                componentObj.direction = 'ENTRY';
            } else {
                if (vm.data.stageOne.selectedNetworkPoint.bundled) {
                    componentObj.direction = 'EXIT';
                } else {
                    componentObj.direction =
                        vm.data.stageOne.selectedNetworkPoint.direction;
                }
            }

            return componentObj;
        }
    }
})();
